import React, { Component } from "react";
import "./ExportDetail.scss";

type Props = {
    orders: any[];
    isVisible: boolean;
    fn: any;
};

type State = {};

class ExportDetail extends Component<Props, State> {
    static defaultProps = {
        orders: [],
    };

    render() {
        const exportCount = this.props.orders.length;

        return (
            <span className={"ms-auto ExportDetail " + (this.props.isVisible ? "" : "d-none")}>
                <div className="box">{exportCount}</div>
                <div onClick={this.props.fn} className={"label"}>
                    Export
                </div>
            </span>
        );
    }
}

export default ExportDetail;
